"use client";

import type { ProductOption } from "@/shared/api/services/productService";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface Props {
  option: ProductOption;
  value: string;
  onValueChange: (code: string) => void;
  /** Required selects show the `(+addedPrice)` suffix; optional selects don't. */
  showAddedPrice?: boolean;
  /** Changes any time the selected-items list changes — forces a controlled re-render after selection. */
  resetKey: string | number;
  /** variant code → 비활성 사유 ("품절" 등). 항목은 노출하되 선택 불가. */
  disabledReasons?: Map<string, string>;
}

export function OptionSelect({
  option,
  value,
  onValueChange,
  showAddedPrice = false,
  resetKey,
  disabledReasons,
}: Props) {
  return (
    <Select key={`${option.id}-${resetKey}`} value={value} onValueChange={onValueChange}>
      <SelectTrigger className="w-full h-10 rounded-sm text-[13px]">
        <SelectValue placeholder="옵션을 선택해주세요" />
      </SelectTrigger>
      <SelectContent className="rounded-sm">
        {option.variant
          .filter((v) => v.isOnSale === 1)
          .map((v) => {
            const reason = disabledReasons?.get(v.code);
            return (
              <SelectItem key={v.id} value={v.code} disabled={!!reason} className="text-[13px]">
                {v.name}
                {showAddedPrice &&
                  v.addedPrice > 0 &&
                  ` (+${v.addedPrice.toLocaleString("ko-KR")}원)`}
                {reason && ` (${reason})`}
              </SelectItem>
            );
          })}
      </SelectContent>
    </Select>
  );
}
